import { createGetAvailableLoginMethodConfigUtil } from '@shopee-user/shared-customization-logic/src/biometrics/available-login-method';

const {
  getAvailableLoginMethodConfig,
} = createGetAvailableLoginMethodConfigUtil();

export { getAvailableLoginMethodConfig };
